import { getCookies } from "cookies-next";

import { CUSTOMER_KEY_COOKIE, SESSION_KEY_COOKIE } from "@/config/voyado";
import { uuidv4 } from "@/utils/uuidv4";

export default function getElevateSession() {
  const cookies = getCookies();

  if (
    cookies &&
    CUSTOMER_KEY_COOKIE in cookies &&
    SESSION_KEY_COOKIE in cookies
  ) {
    const customerKey = cookies[CUSTOMER_KEY_COOKIE];
    const sessionKey = cookies[SESSION_KEY_COOKIE];

    return {
      customerKey: typeof customerKey === "string" ? customerKey : uuidv4(),
      sessionKey: typeof sessionKey === "string" ? sessionKey : uuidv4(),
    };
  }

  return { customerKey: uuidv4(), sessionKey: uuidv4() };
}
